import { Autocomplete, FormControl, FormControlLabel, Grid, IconButton, InputAdornment, Checkbox, TextField, List, Paper, ListItem, ListItemText, CircularProgress } from "@mui/material";
import { useEffect, useState, Fragment } from "react";
import { FormLayout } from "../../../../layouts/form";
import { UsersService } from "../../../../services/users";
import { NotificationManager } from "react-notifications";
import { CompaniesService } from "../../../../services/companies";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { VehiclesService } from "../../../../services/vehicles";
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { AccordionForms } from "../../../../components/accordionForms";


export const UserForm = ({ onClose, defaultValues }) => {
    const typeUsers = [{ label: "Usuário", id: 1 }, { label: "Operador", id: 2 }, { label: "Administrador", id: 3 }];
    const usersService = new UsersService();
    const companiesService = new CompaniesService();
    const vehiclesService = new VehiclesService();

    const [saving, setSaving] = useState(false);
    const [disableSaveButton, setDisableSaveButton] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState(defaultValues ? { value: defaultValues.companyId } : null);
    const [typesOperationByCompany, setTypesOperationByCompany] = useState([]);
    const [typeOperationSelected, setTypeOperationSelected] = useState(defaultValues ? defaultValues.operations : []);
    const [showPassword, setShowPassword] = useState(false);
    const [passwordValue, setPasswordValue] = useState();
    const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
    const [passwordConfirmationValue, setPasswordConfirmationValue] = useState();
    const [showPasswordConfirmationError, setShowPasswordConfirmationError] = useState(false);
    const [showEmailConfirmation, setShowEmailConfirmation] = useState(false);
    const [userTypeSelected, setUserTypeSelected] = useState(defaultValues ? typeUsers.filter(item1 => item1.label === defaultValues.userType) : null);
    const [vehiclesByCompany, setVehiclesByCompany] = useState([]);
    const [vehiclesOptions, setVehiclesOptions] = useState([]);
    const [blueprintsByCompany, setBlueprintsByCompany] = useState(defaultValues ? defaultValues.blueprint : []);
    const [blueprintSelected, setBlueprintSelected] = useState(defaultValues ? defaultValues.blueprint : []);
    const [vehiclesSelected, setVehiclesSelected] = useState(defaultValues ? defaultValues.vehicles : []);
    const [automaticReport, setAutomaticReport] = useState(defaultValues ? defaultValues.automaticReport : false);
    const [showPlant, setShowPlant] = useState(defaultValues ? true : false);
    const [showVehicles, setShowVehicles] = useState(defaultValues ? true : false);
    const [showTypesOperations, setShowTypesOperations] = useState(defaultValues ? true : false);

    const [inputValueBlueprint, setInputValueBlueprint] = useState(null);
    const [inputValueTypeOperation, setInputValueTypeOperation] = useState(null);
    const [inputValueVehicles, setInputValueVehicles] = useState(null);
    const [loading, setLoading] = useState(false);
    const [openBlueprint, setOpenBlueprint] = useState(false);
    const [openVehicles, setOpenVehicles] = useState(false);
    const [selectionState, setSelectionState] = useState(0); //0 nada, 1 planta, 2 operacao, 3 ambos

    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);

    const handleClickShowPasswordConfirmation = () => setShowPasswordConfirmation(!showPasswordConfirmation);
    const handleMouseDownPasswordConfirmation = () => setShowPasswordConfirmation(!showPasswordConfirmation);

    const checkPasswordMatch = (password, passwordConfirmation) => {
        const checkEqual = (password ? password : passwordValue) !== (passwordConfirmation ? passwordConfirmation : passwordConfirmationValue);
        const checkNotEmpty = (password ? password : passwordValue) !== '' && (passwordConfirmation ? passwordConfirmation : passwordConfirmationValue) !== '';
        setShowPasswordConfirmationError(checkEqual && checkNotEmpty);
    }

    useEffect(() => {
        getCompanies();
        if (defaultValues) {
            let typeOperationCompany = [];
            companiesService.getCompany(selectedCompanyId.value).then((response) => {
                let opt = [];
                let blueprints = [{ id: 0, label: "TODAS" }];
                let tempBlue = [];
                response.data.typesOperation.forEach((element, index) => {
                    opt.push(element.toUpperCase());
                });
                response.data.blueprint.forEach((element, index) => {
                    blueprints.push({ id: index + 1, label: element.toUpperCase() })
                    tempBlue.push(element.toUpperCase());
                });
                if (opt.includes("TODOS")) {
                    opt = opt.filter(element => element != "TODOS");
                    opt.push("TODOS");
                }
                typeOperationCompany = opt;
                
                let newBlueprintSelected = [];
                blueprintSelected.forEach(element => {
                    if (tempBlue.includes(element)) {
                        newBlueprintSelected.push(element);
                    }
                });
                setBlueprintSelected(newBlueprintSelected);

                let newTypeOperationSelected = [];
                typeOperationSelected.forEach(element => {
                    if (typeOperationCompany.includes(element)) {
                        newTypeOperationSelected.push(element);
                    }
                });
                setTypeOperationSelected(newTypeOperationSelected);

                setBlueprintsByCompany(blueprints);
                setTypesOperationByCompany(opt);
            }).catch((error) => {
                console.error(error);
            });

            vehiclesService.getAllPlates(selectedCompanyId.value).then((response) => {
                let opt = [];
                if (response.data.length > 0) {
                    opt.push({ plate: "TODOS", blueprint: "", typeOperation: "" });
                    let companyOpt = [];
                    response.data.forEach((element, index) => {
                        if (element.typeOperation == "SALA1" || element.typeOperation == "SALA2" || element.typeOperation == "SALA3" || element.typeOperation == "SALA4") {
                            element.typeOperation = "GRANJAS";
                            companyOpt.push(element);
                        } else {
                            companyOpt.push(element);
                        }
                    });
                    if (typeOperationSelected.length !== 0) {
                        if (typeOperationSelected.includes("TODOS")) {
                            if (blueprintSelected.length !== 0) {
                                companyOpt.forEach(element => {
                                    if (blueprintSelected.includes(element.blueprint.toUpperCase()) && element.typeOperation !== '' && typeOperationCompany.includes(element.typeOperation)) {
                                        opt.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
                                    }
                                });
                            } else {
                                companyOpt.forEach(element => {
                                    if (element.typeOperation !== '' && typeOperationCompany.includes(element.typeOperation)) {
                                        opt.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
                                    }
                                });
                            }
                        } else {
                            if (blueprintSelected.length !== 0) {
                                companyOpt.forEach(element => {
                                    if (blueprintSelected.includes(element.blueprint.toUpperCase()) && typeOperationSelected.includes(element.typeOperation.toUpperCase())) {
                                        opt.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
                                    }
                                });
                            } else {
                                companyOpt.forEach(element => {
                                    if (typeOperationSelected.includes(element.typeOperation.toUpperCase())) {
                                        opt.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
                                    }
                                });
                            }
                        }
                    }
                    if (opt.length === 1) {
                        opt = [];
                    }
                    setVehiclesOptions([...new Set([...vehiclesOptions, ...opt])]);
                    setVehiclesByCompany([...new Set([...vehiclesByCompany, ...companyOpt])]);
                }
            }).catch((error) => {
                console.error(error);
            });

            if (defaultValues.blueprint.length === 0) {
                setBlueprintSelected([]);
                setShowPlant(false);
            }

            if (defaultValues.operations.length === 0) {
                setTypeOperationSelected([]);
                setShowTypesOperations(false);
            }

            if (defaultValues.vehicles.length === 0) {
                setVehiclesSelected([]);
                setShowVehicles(false);
            }

            if (defaultValues.blueprint.length !== 0) {
                if (defaultValues.operations.length !== 0) {
                    setSelectionState(3);
                } else {
                    setSelectionState(1);
                }
            } else if (defaultValues.operations.length !== 0) {
                setSelectionState(2);
            } else {
                setSelectionState(0);
            }
        }
    }, [defaultValues]);

    const checkEmail = (email) => {
        var regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        const checkEmail = String(email).toLowerCase().match(regex);
        if (checkEmail != null) {
            setShowEmailConfirmation(false);
        } else {
            setShowEmailConfirmation(true);
        }
    }

    const handleCreationSuccess = () => {
        NotificationManager.success('Usuário criado com sucesso.', "", 3000);
        setSaving(false);
        setDisableSaveButton(false);
        onClose();
    }

    const getCompanies = () => {
        companiesService.getCompanies().then(res => {
            const companiesToOptions = res.data;
            let options = [];
            companiesToOptions.forEach(c => {
                options.push({
                    label: c.name,
                    value: c.id,
                    typesOperation: c.typesOperation.map(function (x) { return x.toUpperCase(); }),
                    blueprint: c.blueprint.map(function (x) { return x.toUpperCase(); }),
                });
            });

            setCompanies(options);
            if (defaultValues) {
                for (var key in options) {
                    if (options[key].value === defaultValues.companyId) {
                        handleSelectCompany(options[key]);
                    }
                }
            }
        }).catch(error => {
            console.error(error);
        });
    }

    /**
     * Save a new user or update user
     */
    function handleSaveClick(formData) {
        const data = new FormData(formData);

        if (defaultValues) {
            const name = data.get('name');
            const username = data.get('username');
            const password = data.get('password');
            const email = data.get('email');

            setSaving(true);
            const newUser = {
                "id": defaultValues.id,
                "name": name,
                "username": username,
                "password": password,
                "email": email,
                "userType": userTypeSelected && userTypeSelected.length > 0 ? userTypeSelected[0].id : userTypeSelected.id,
                "companyId": selectedCompanyId.value,
                "operations": typeOperationSelected,
                "automaticReport": automaticReport,
                "blueprint": blueprintSelected,
                "vehicles": vehiclesSelected,
            };
            usersService.updateUser(newUser).then((response) => {
                if (response.status === 200) {
                    NotificationManager.success("Usuário atualizado com sucesso!", "", 3000);
                }
                setSaving(false);
                setDisableSaveButton(false);
                onClose();

            }).catch((error) => {
                console.error(error);
            });

            setSaving(false);
        } else {
            const name = data.get('name');
            const username = data.get('username');
            const password = data.get('password');
            const email = data.get('email');
            const company = data.get('companyId');
            const userType = data.get('userType');
            if (!validateFields(name, username, password, email, company, userType)) {
                setSaving(false);
                setDisableSaveButton(false);
                return;
            }

            setSaving(true);

            const newUser = {
                "name": name,
                "username": username,
                "password": password,
                "email": email,
                "userType": userTypeSelected.id,
                "companyId": selectedCompanyId.value,
                "operations": typeOperationSelected,
                "automaticReport": automaticReport,
                "blueprint": blueprintSelected,
                "vehicles": vehiclesSelected,
            };

            usersService.createUser(newUser)
                .then(() => {
                    handleCreationSuccess();
                })
                .catch((error) => {
                    console.error(error);
                    setSaving(false);
                    setDisableSaveButton(false);
                });
        }

    }

    /**
     * Validate the fields
     * @returns
     */
    function validateFields(name, username, password, email, company, userType) {
        let hasError = true;

        if (name === "" || username === "" || password === "" || email === "" || showEmailConfirmation !== false || company === "" || userType === "") {
            NotificationManager.warning('É preciso preencher todos os campos.', "", 3000);
            hasError = false;
        }

        return hasError;
    }

    const handleSelectCompany = (newValue) => {
        if (newValue != null && newValue.value !== selectedCompanyId) {
            setSelectedCompanyId(newValue);
            if (newValue.typesOperation !== '') {
                if (newValue.typesOperation.includes("TODOS")) {
                    newValue.typesOperation = newValue.typesOperation.filter(element => element != "TODOS");
                    newValue.typesOperation.push("TODOS");
                }
                setTypesOperationByCompany(newValue.typesOperation.map(function (x) { return x.toUpperCase(); }));
            } else {
                NotificationManager.warning("Sem operações cadastradas para a empresa!", "", 3000);
                setTypesOperationByCompany([]);
            }
            companiesService.getBlueprints(newValue.value).then((response) => {
                if (response.status === 204) {
                    NotificationManager.warning("Sem plantas cadastradas para a empresa!", "", 3000);
                    setBlueprintsByCompany([]);
                } else if (response.status === 200) {
                    let opt = [{ id: 0, label: "TODAS" }];
                    response.data.forEach((element, index) => {
                        opt.push({ id: index + 1, label: element.toUpperCase() })
                    });
                    setBlueprintsByCompany(opt);
                }
            }).catch((error) => {
                console.error(error);
            })

            vehiclesService.getAllPlates(newValue.value).then((response) => {
                if (response.status === 204) {
                    NotificationManager.warning("Sem veículos cadastrados para a empresa!", "", 3000);
                    setVehiclesOptions([]);
                }
                else if (response.status === 200) {
                    let opt = [];
                    response.data.forEach((element, index) => {
                        if (element.typeOperation == "SALA1" || element.typeOperation == "SALA2" || element.typeOperation == "SALA3" || element.typeOperation == "SALA4") {
                            element.typeOperation = "GRANJAS";
                            opt.push(element);
                        } else {
                            opt.push(element);
                        }
                    });
                    setVehiclesByCompany(opt);
                }
            }).catch((error) => {
                console.error(error);
            });

            if (defaultValues == null) {
                setBlueprintSelected([]);
                setTypeOperationSelected([]);
                setVehiclesSelected([]);
                setVehiclesOptions([]);
                setShowPlant(false);
                setShowTypesOperations(false);
                setShowVehicles(false);
            }
        } else {
            setSelectedCompanyId(null);
            setTypesOperationByCompany([]);
            setBlueprintsByCompany([]);
            setBlueprintSelected([]);
            setTypeOperationSelected([]);
            setVehiclesSelected([]);
            setVehiclesOptions([]);
            setShowPlant(false);
            setShowTypesOperations(false);
            setShowVehicles(false);
        }
    }

    const handleSelectTypeOperation = (newValue) => {
        if (newValue != null) {
            if (typeOperationSelected.includes("TODOS")) {
                NotificationManager.warning('Operação "TODOS" engloba todas as operações da empresa!', "", 3000);
            } else if (typeOperationSelected.includes(newValue)) {
                NotificationManager.warning('Operação já adicionada!', "", 3000);
            } else if (newValue === "TODOS") {
                setTypeOperationSelected([newValue]);
                setShowTypesOperations(true);
                let newPlates = [];
                newPlates.push({ plate: "TODOS", blueprint: "", typeOperation: "" });
                // if (blueprintSelected.length === 0) {
                //     vehiclesByCompany.forEach(element => {
                //         if (typesOperationByCompany.includes(element.typeOperation.toUpperCase())) {
                //             newPlates.push({plate:element.plate, blueprint:element.blueprint.toUpperCase(), typeOperation:element.typeOperation.toUpperCase()});
                //         }
                //     });
                //     if (newPlates.length === 1) {
                //         newPlates = [];
                //     }
                //     setVehiclesOptions(newPlates);
                //     setSelectionState(2);
                // }
                if (blueprintSelected.length !== 0) {
                    vehiclesByCompany.forEach(element => {
                        if (blueprintSelected.includes(element.blueprint.toUpperCase()) && typesOperationByCompany.includes(element.typeOperation.toUpperCase())) {
                            newPlates.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
                        }
                    });
                    if (newPlates.length === 1) {
                        newPlates = [];
                    }
                    setVehiclesOptions(newPlates);
                    setSelectionState(3);
                }
            }
            else {
                const operations = [...typeOperationSelected, newValue];
                setTypeOperationSelected(operations);
                setShowTypesOperations(true);
                const newVehiclesFilteredByTypeOperations = vehiclesByCompany.filter(item1 => operations.some(item2 => item1.typeOperation.toUpperCase() === item2.toUpperCase()));
                let newPlates = [];
                newPlates.push({ plate: "TODOS", blueprint: "", typeOperation: "" });
                if (blueprintSelected.length !== 0) {
                    newVehiclesFilteredByTypeOperations.forEach(element => {
                        if (blueprintSelected.includes(element.blueprint.toUpperCase())) {
                            newPlates.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
                        }
                    });
                    if (newPlates.length === 1) {
                        newPlates = [];
                    }
                    setVehiclesOptions(newPlates);
                    setSelectionState(3);
                }
                // else {
                //     newVehiclesFilteredByTypeOperations.forEach(element => {
                //         newPlates.push({plate:element.plate, blueprint:element.blueprint.toUpperCase(), typeOperation:element.typeOperation.toUpperCase()});
                //     });
                //     if (newPlates.length === 1) {
                //         newPlates = [];
                //     }
                //     setVehiclesOptions(newPlates);
                //     setSelectionState(2);
                // }
                setVehiclesSelected([]);
                setShowVehicles(false);
            }
        }
        setInputValueTypeOperation(null);

    }

    const handleSelectBlueprint = (newValue) => {
        if (newValue != null) {
            if (newValue.label === "TODAS") {
                var blueprint = [];
                for (var key in blueprintsByCompany) {
                    if (blueprintsByCompany[key].label.toUpperCase() !== "TODAS") {
                        blueprint.push(blueprintsByCompany[key].label.toUpperCase());
                    }
                }
                setBlueprintSelected(blueprint);
                setShowPlant(true);
                // if (typeOperationSelected.length === 0) {
                //     let opt = [];
                //     opt.push({plate:"TODOS", blueprint:"", typeOperation:""});
                //     vehiclesByCompany.forEach(element => {
                //         if (blueprint.includes(element.blueprint.toUpperCase())) {
                //             opt.push({plate:element.plate, blueprint:element.blueprint.toUpperCase(), typeOperation:element.typeOperation.toUpperCase()});
                //         }
                //     });
                //     if (opt.length === 1) {
                //         opt = [];
                //     }
                //     setVehiclesOptions(opt);
                //     setSelectionState(1);
                // }
                if (typeOperationSelected.length !== 0) {
                    let opt = [];
                    opt.push({ plate: "TODOS", blueprint: "", typeOperation: "" });
                    if (typeOperationSelected.includes("TODOS")) {
                        vehiclesByCompany.forEach((element) => {
                            if (blueprint.includes(element.blueprint.toUpperCase()) && typesOperationByCompany.includes(element.typeOperation.toUpperCase())) {
                                opt.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
                            }
                        });
                    } else {
                        vehiclesByCompany.forEach((element) => {
                            if (blueprint.includes(element.blueprint.toUpperCase()) && typeOperationSelected.includes(element.typeOperation.toUpperCase())) {
                                opt.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
                            }
                        });
                    }
                    if (opt.length === 1) {
                        opt = [];
                    }
                    setVehiclesOptions(opt);
                    setSelectionState(3);
                }

            } else {
                if (!blueprintSelected.includes(newValue.label.toUpperCase())) {
                    const listBlueprints = [...blueprintSelected, newValue.label.toUpperCase()];
                    setBlueprintSelected(listBlueprints);
                    setShowPlant(true);
                    // if (typeOperationSelected.length === 0) {
                    //     let opt = [];
                    //     opt.push({plate:"TODOS", blueprint:"", typeOperation:""});
                    //     vehiclesByCompany.forEach((element) => {
                    //         if (listBlueprints.includes(element.blueprint.toUpperCase())) {
                    //             opt.push({plate:element.plate, blueprint:element.blueprint.toUpperCase(), typeOperation:element.typeOperation.toUpperCase()});
                    //         }
                    //     });
                    //     if (opt.length === 1) {
                    //         opt = [];
                    //     }
                    //     setVehiclesOptions(opt);
                    //     setSelectionState(1);
                    // }
                    if (typeOperationSelected.length !== 0) {
                        let opt = [];
                        opt.push({ plate: "TODOS", blueprint: "", typeOperation: "" });
                        if (typeOperationSelected.includes("TODOS")) {
                            vehiclesByCompany.forEach((element) => {
                                if (listBlueprints.includes(element.blueprint.toUpperCase()) && typesOperationByCompany.includes(element.typeOperation.toUpperCase())) {
                                    opt.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
                                }
                            });
                        } else {
                            vehiclesByCompany.forEach((element) => {
                                if (typeOperationSelected.includes(element.typeOperation.toUpperCase()) && listBlueprints.includes(element.blueprint.toUpperCase())) {
                                    opt.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
                                }

                            });
                        }
                        if (opt.length === 1) {
                            opt = [];
                        }
                        setVehiclesOptions(opt);
                        setSelectionState(3);
                    }
                } else if (blueprintSelected.includes(newValue.label)) {
                    NotificationManager.warning('Planta já adicionada!', "", 3000);
                }
            }
        }
        setInputValueBlueprint(null);
    }

    const handleSelectUserType = (newValue) => {
        setUserTypeSelected(newValue);
    }

    const handleSelectVehicles = (newValue) => {
        if (newValue !== null) {
            if (newValue.plate === "TODOS") {
                var vehicles = [];
                for (var key in vehiclesByCompany) {
                    if (vehiclesByCompany[key].plate !== "TODOS") {
                        if (blueprintSelected.length !== 0) {
                            if (blueprintSelected.includes(vehiclesByCompany[key].blueprint.toUpperCase())) {
                                if (typeOperationSelected.length === 0) {
                                    vehicles.push(vehiclesByCompany[key].plate);
                                } else {
                                    if (typeOperationSelected.includes("TODOS") && vehiclesByCompany[key].typeOperation !== '' && typesOperationByCompany.includes(vehiclesByCompany[key].typeOperation)) {
                                        vehicles.push(vehiclesByCompany[key].plate);
                                    } else if (typeOperationSelected.includes(vehiclesByCompany[key].typeOperation.toUpperCase())) {
                                        vehicles.push(vehiclesByCompany[key].plate);
                                    }
                                }
                            }
                        } else if (typeOperationSelected.length !== 0) {
                            if (typeOperationSelected.includes("TODOS") && vehiclesByCompany[key].typeOperation !== '' && typesOperationByCompany.includes(vehiclesByCompany[key].typeOperation)) {
                                vehicles.push(vehiclesByCompany[key].plate);
                            } else if (typeOperationSelected.includes(vehiclesByCompany[key].typeOperation.toUpperCase())) {
                                vehicles.push(vehiclesByCompany[key].plate);
                            }
                        } else {
                            vehicles.push(vehiclesByCompany[key].plate);
                        }
                    }
                }

                setVehiclesSelected(vehicles);
                setShowVehicles(true);
            } else if (!vehiclesSelected.includes(newValue.plate)) {
                setVehiclesSelected([...vehiclesSelected, newValue.plate]);
                setShowVehicles(true);
            } else if (vehiclesSelected.includes(newValue.plate)) {
                NotificationManager.warning('Veículo já adicionado!', "", 3000);
            }
        }
        setInputValueVehicles(null);
    }

    const handleAutomaticReport = (newValue) => {
        setAutomaticReport(newValue);
    }

    const handleRemoveBluePrint = (indexItem) => {
        const updatedList = blueprintSelected.filter((_, index) => index !== indexItem);
        setBlueprintSelected(updatedList);
        if (updatedList.length === 0) {
            setShowPlant(false);
            // if (typeOperationSelected.length !== 0) {
            //     let opt = [];
            //     opt.push({plate:"TODOS", blueprint:"", typeOperation:""});
            //     if (typeOperationSelected.includes("TODOS")) {
            //         vehiclesByCompany.forEach((element, index) => {
            //             if (typesOperationByCompany.includes(element.typeOperation.toUpperCase())) {
            //                 opt.push({plate:element.plate, blueprint:element.blueprint.toUpperCase(), typeOperation:element.typeOperation.toUpperCase()});
            //             }
            //         });
            //     } else {
            //         vehiclesByCompany.forEach((element, index) => {
            //             if (typeOperationSelected.includes(element.typeOperation.toUpperCase())) {
            //                 opt.push({plate:element.plate, blueprint:element.blueprint.toUpperCase(), typeOperation:element.typeOperation.toUpperCase()});
            //             }
            //         });
            //     }
            //     if (opt.length === 1) {
            //         opt = [];
            //     }
            //     setVehiclesOptions(opt);
            //     setSelectionState(2);
            // } else {
            setVehiclesOptions([]);
            setSelectionState(0);
            // }
        }
        else {
            // if (typeOperationSelected.length === 0) {
            //     let opt = [];
            //     opt.push({plate:"TODOS", blueprint:"", typeOperation:""});
            //     vehiclesByCompany.forEach(element => {
            //         if (updatedList.includes(element.blueprint.toUpperCase())) {
            //             opt.push({plate:element.plate, blueprint:element.blueprint.toUpperCase(), typeOperation:element.typeOperation.toUpperCase()});
            //         }
            //     });
            //     if (opt.length === 1) {
            //         opt = [];
            //     }
            //     setVehiclesOptions(opt);
            //     setShowPlant(true);
            //     setSelectionState(1);
            // }
            if (typeOperationSelected.length !== 0) {
                let opt = [];
                opt.push({ plate: "TODOS", blueprint: "", typeOperation: "" });
                if (typeOperationSelected.includes("TODOS")) {
                    vehiclesByCompany.forEach((element, index) => {
                        if (updatedList.includes(element.blueprint.toUpperCase()) && typesOperationByCompany.includes(element.typeOperation.toUpperCase())) {
                            opt.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
                        }
                    });
                } else {
                    vehiclesByCompany.forEach((element, index) => {
                        if (typeOperationSelected.includes(element.typeOperation.toUpperCase()) && updatedList.includes(element.blueprint.toUpperCase())) {
                            opt.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
                        }
                    });
                }
                if (opt.length === 1) {
                    opt = [];
                }
                setVehiclesOptions(opt);
                setShowPlant(true);
                setSelectionState(3);
            }
        }
        setVehiclesSelected([]);
        setShowVehicles(false);
    }

    const handleRemoveTypeOperation = (indexItem) => {
        const updatedList = typeOperationSelected.filter((_, index) => index !== indexItem);
        setTypeOperationSelected(updatedList);
        if (updatedList.length === 0) {
            setShowTypesOperations(false);
            // if (blueprintSelected.length !== 0) {
            //     let opt = [];
            //     opt.push({plate:"TODOS", blueprint:"", typeOperation:""});            
            //     vehiclesByCompany.forEach((element, index) => {
            //         if (blueprintSelected.includes(element.blueprint.toUpperCase())) {
            //             opt.push({plate:element.plate, blueprint:element.blueprint.toUpperCase(), typeOperation:element.typeOperation.toUpperCase()});
            //         }
            //     });
            //     if (opt.length === 1) {
            //         opt = [];
            //     }
            //     setVehiclesOptions(opt);
            //     setShowTypesOperations(false);
            //     setSelectionState(1);
            // } else {
            setVehiclesOptions([]);
            setSelectionState(0);
            // }
        }
        else {
            if (blueprintSelected.length !== 0) {
                let newPlates = [];
                newPlates.push({ plate: "TODOS", blueprint: "", typeOperation: "" });
                if (updatedList.includes("TODOS")) {
                    vehiclesByCompany.forEach(element => {
                        if (blueprintSelected.includes(element.blueprint.toUpperCase()) && typesOperationByCompany.includes(element.typeOperation.toUpperCase())) {
                            newPlates.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
                        }
                    });
                } else {
                    vehiclesByCompany.forEach(element => {
                        if (updatedList.includes(element.typeOperation.toUpperCase()) && blueprintSelected.includes(element.blueprint.toUpperCase())) {
                            newPlates.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
                        }
                    });
                }
                if (newPlates.length === 1) {
                    newPlates = [];
                }
                setVehiclesOptions(newPlates);
                setShowTypesOperations(true);
                setSelectionState(3);
            }
            // else {
            //     let opt = [];
            //     opt.push({plate:"TODOS", blueprint:"", typeOperation:""});
            //     if (updatedList.includes("TODOS")) {
            //         vehiclesByCompany.forEach((element, index) => {
            //             if (typesOperationByCompany.includes(element.typeOperation.toUpperCase())) {
            //                 opt.push({plate:element.plate, blueprint:element.blueprint.toUpperCase(), typeOperation:element.typeOperation.toUpperCase()});
            //             }
            //         });
            //     } else {
            //         vehiclesByCompany.forEach((element, index) => {
            //             if (updatedList.includes(element.typeOperation.toUpperCase())) {
            //                 opt.push({plate:element.plate, blueprint:element.blueprint.toUpperCase(), typeOperation:element.typeOperation.toUpperCase()});
            //             }
            //         });
            //     }
            //     if (opt.length === 1) {
            //         opt = [];
            //     }
            //     setVehiclesOptions(opt);
            //     setShowTypesOperations(true);
            //     setSelectionState(2);
            // }
        }
        setVehiclesSelected([]);
        setShowVehicles(false);
    }

    const handleRemoveVehicle = (indexItem) => {
        const updatedList = vehiclesSelected.filter((_, index) => index !== indexItem);
        setVehiclesSelected(updatedList);
        if (updatedList.length === 0) {
            setShowVehicles(false);
        }
    }

    function sleep(duration) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, duration);
        });
    }

    const handleOpenBlueprint = () => {
        setOpenBlueprint(true);
        (async () => {
            setLoading(true);
            await sleep(20);
            setLoading(false);
        })();
    };

    const handleCloseBlueprint = () => {
        setOpenBlueprint(false);
    };

    const handleOpenVehicle = () => {
        let opt = [];
        if (selectionState === 1) {
            // vehiclesOptions.forEach(element => {
            //     opt.push({plate:element.plate, blueprint:element.blueprint.toUpperCase()});
            // });
            // opt = opt.sort((a,b) => a.blueprint.localeCompare(b.blueprint));
            // setVehiclesOptions(opt);
            setVehiclesOptions([]);
        } else if (selectionState === 2) {
            // vehiclesOptions.forEach(element => {
            //     opt.push({plate:element.plate, typeOperation:element.typeOperation.toUpperCase()});
            // });
            // opt = opt.sort((a,b) => a.typeOperation.localeCompare(b.typeOperation));
            // setVehiclesOptions(opt);
            setVehiclesOptions([]);
        } else if (selectionState === 3) {
            vehiclesOptions.forEach(element => {
                opt.push({ plate: element.plate, blueprint: element.blueprint.toUpperCase(), typeOperation: element.typeOperation.toUpperCase() });
            });
            opt = opt.sort((a, b) => a.typeOperation.localeCompare(b.typeOperation) || a.blueprint.localeCompare(b.blueprint));
            setVehiclesOptions(opt);
        }
        setOpenVehicles(true);
        (async () => {
            setLoading(true);
            await sleep(20);
            setLoading(false);
        })();
    };

    const handleCloseVehicle = () => {
        setOpenVehicles(false);
    };

    const formatInput = (event) => {
        let temp = event.target.value;
        temp = temp.trim();
        event.target.value = temp;
    }

    const styleBorderField = (width) => {
        return ({
            boxShadow: '1px 1px 3px 1px rgb(217, 217, 217)',
            borderRadius: '6px',
            width: width,
        });
    }

    return (
        <FormLayout onSaveClick={handleSaveClick} saving={saving} disableButton={disableSaveButton}>
            <Grid container spacing={2}>

                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <Autocomplete
                            id="companyId"
                            name="companyId"
                            options={companies}
                            onChange={(event, newValue) => handleSelectCompany(newValue)}
                            renderInput={(params) => <TextField {...params} label="Empresa" required />}
                            defaultValue={defaultValues ? defaultValues.companyName : ''}
                            size="small"
                            sx={styleBorderField("100%")}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        label="Nome"
                        id="name"
                        name="name"
                        required
                        variant="outlined"
                        fullWidth
                        defaultValue={defaultValues ? defaultValues.name : ''}
                        onBlur={formatInput}
                        size="small"
                        sx={styleBorderField("100%")}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        label="Email"
                        id="email"
                        name="email"
                        fullWidth
                        required
                        variant="outlined"
                        defaultValue={defaultValues ? defaultValues.email : ''}
                        size="small"
                        error={showEmailConfirmation}
                        onChange={e => { checkEmail(e.target.value) }}
                        onBlur={formatInput}
                        sx={styleBorderField("100%")}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        label="Usuário"
                        id="username"
                        name="username"
                        required
                        variant="outlined"
                        fullWidth
                        defaultValue={defaultValues ? defaultValues.username : ''}
                        onBlur={formatInput}
                        size="small"
                        sx={styleBorderField("100%")}
                    />
                </Grid>

                <Grid item xs={6}>
                    <FormControl fullWidth >
                        <Autocomplete
                            id="blueprint"
                            name="blueprint"
                            open={openBlueprint}
                            onOpen={handleOpenBlueprint}
                            onClose={handleCloseBlueprint}
                            loading={loading}
                            loadingText={"Carregando..."}
                            options={blueprintsByCompany}
                            onChange={(event, newValue) => { handleSelectBlueprint(newValue) }}
                            value={inputValueBlueprint}
                            renderInput={(params) => <TextField
                                {...params}
                                label="Plantas"
                                defaultValue={""}
                                slotprops={{
                                    input: {
                                        ...params.InputProps,
                                        endAdornment: (
                                            <Fragment>
                                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </Fragment>
                                        ),
                                    },
                                }}
                            />}
                            size="small"
                            sx={styleBorderField("100%")}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <Autocomplete
                            id="typeOperation"
                            name="typeOperation"
                            options={typesOperationByCompany}
                            onChange={(event, newValue) => { handleSelectTypeOperation(newValue) }}
                            value={inputValueTypeOperation}
                            renderInput={(params) => <TextField {...params} label="Tipo de Operação" />}
                            size="small"
                            sx={styleBorderField("100%")}
                        />
                    </FormControl>

                </Grid>

                {showPlant && <Grid item xs={6}>
                    <List dense style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                        {defaultValues !== undefined ?
                            <AccordionForms
                                title={"Plantas Adicionadas"}
                                width={"100%"}
                                height={"70px"}
                                children={
                                    <List dense style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                        {
                                            blueprintSelected.map((element, index) => {
                                                return (
                                                    <Paper elevation={3} variant="outlined" style={{ marginRight: "5px", marginTop: '2px', borderRadius: '32px', borderWidth: 2, height: '30px', display: 'flex', alignItems: 'center', width: "fit-content" }}>
                                                        <ListItem
                                                            secondaryAction={
                                                                <IconButton
                                                                    edge="end"
                                                                    aria-label="delete"
                                                                    onClick={() => handleRemoveBluePrint(index)}
                                                                    style={{ backgroundColor: 'rgb(251, 191, 180)', height: '20px', width: '20px' }}
                                                                >
                                                                    <DeleteRoundedIcon color="error" fontSize={'small'} />
                                                                </IconButton>
                                                            }
                                                        >
                                                            <ListItemText
                                                                primary={element}
                                                                disableTypography={true}
                                                                style={{ fontSize: '10px' }}
                                                            />
                                                        </ListItem>
                                                    </Paper>
                                                )
                                            })
                                        }
                                    </List>
                                }
                            />
                            :
                            <AccordionForms
                                title={"Plantas Adicionadas"}
                                width={"100%"}
                                height={"70px"}
                                children={
                                    <List dense style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                        {
                                            blueprintSelected.map((element, index) => {
                                                return (
                                                    <Paper elevation={3} variant="outlined" style={{ marginRight: "5px", marginTop: '2px', borderRadius: '32px', borderWidth: 2, height: '30px', display: 'flex', alignItems: 'center', width: "fit-content" }}>
                                                        <ListItem
                                                            secondaryAction={
                                                                <IconButton
                                                                    edge="end"
                                                                    aria-label="delete"
                                                                    onClick={() => handleRemoveBluePrint(index)}
                                                                    style={{ backgroundColor: 'rgb(251, 191, 180)', height: '20px', width: '20px' }}
                                                                >
                                                                    <DeleteRoundedIcon color="error" fontSize={'small'} />
                                                                </IconButton>
                                                            }
                                                        >
                                                            <ListItemText
                                                                primary={element}
                                                                disableTypography={true}
                                                                style={{ fontSize: '10px' }}
                                                            />
                                                        </ListItem>
                                                    </Paper>
                                                )
                                            })
                                        }
                                    </List>
                                }
                            />
                        }
                    </List>
                </Grid>}
                {showPlant && !showTypesOperations && <Grid item xs={6}></Grid>}
                {!showPlant && showTypesOperations && <Grid item xs={6}></Grid>}
                {showTypesOperations && <Grid item xs={6}>
                        <List dense style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                            {defaultValues ?
                                <AccordionForms
                                    title={"Tipos de Operação Adicionados"}
                                    width={"100%"}
                                    height={"70px"}
                                    children={
                                        <List dense style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                            {
                                                typeOperationSelected.map((element, index) => {
                                                    return (
                                                        <Paper elevation={3} variant="outlined" style={{ marginRight: "5px", marginTop: '2px', borderRadius: '32px', borderWidth: 2, height: '30px', display: 'flex', alignItems: 'center', width: "fit-content" }}>
                                                            <ListItem
                                                                secondaryAction={
                                                                    <IconButton
                                                                        edge="end"
                                                                        aria-label="delete"
                                                                        onClick={() => handleRemoveTypeOperation(index)}
                                                                        style={{ backgroundColor: 'rgb(251, 191, 180)', height: '20px', width: '20px' }}
                                                                    >
                                                                        <DeleteRoundedIcon color="error" fontSize={'small'} />
                                                                    </IconButton>
                                                                }
                                                            >
                                                                <ListItemText
                                                                    primary={element}
                                                                    disableTypography={true}
                                                                    style={{ fontSize: '10px' }}
                                                                />
                                                            </ListItem>
                                                        </Paper>
                                                    )
                                                })
                                            }
                                        </List>
                                    }
                                />
                                :
                                <AccordionForms
                                    title={"Tipos de Operação Adicionados"}
                                    width={"100%"}
                                    height={"70px"}
                                    children={
                                        <List dense style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                            {
                                                typeOperationSelected.map((element, index) => {
                                                    return (
                                                        <Paper elevation={3} variant="outlined" style={{ marginRight: "5px", marginTop: '2px', borderRadius: '32px', borderWidth: 2, height: '30px', display: 'flex', alignItems: 'center', width: "fit-content" }}>
                                                            <ListItem
                                                                secondaryAction={
                                                                    <IconButton
                                                                        edge="end"
                                                                        aria-label="delete"
                                                                        onClick={() => handleRemoveTypeOperation(index)}
                                                                        style={{ backgroundColor: 'rgb(251, 191, 180)', height: '20px', width: '20px' }}
                                                                    >
                                                                        <DeleteRoundedIcon color="error" fontSize={'small'} />
                                                                    </IconButton>
                                                                }
                                                            >
                                                                <ListItemText
                                                                    primary={element}
                                                                    disableTypography={true}
                                                                    style={{ fontSize: '10px' }}
                                                                />
                                                            </ListItem>
                                                        </Paper>
                                                    )
                                                })
                                            }
                                        </List>
                                    }
                                />
                            }
                        </List>
                    </Grid>
                }

                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <Autocomplete
                            id="vehicles"
                            name="vehicles"
                            open={openVehicles}
                            onOpen={handleOpenVehicle}
                            onClose={handleCloseVehicle}
                            loading={loading}
                            loadingText={"Carregando..."}
                            options={vehiclesOptions}
                            getOptionLabel={(option) => option.plate}
                            groupBy={(option) => `${option.blueprint} > ${option.typeOperation}`}
                            renderGroup={(params) => {
                                const [group, subgroup] = params.group.split('>');
                                if (params.children[0].key !== "TODOS") {
                                    if (selectionState === 0) {
                                        return (
                                            <li key={params.key}>
                                                <div>{params.children}</div>
                                            </li>
                                        );
                                    } else if (selectionState === 1) {
                                        if (group !== ' ') {
                                            return (
                                                <li key={params.key}>
                                                    <div style={{ marginLeft: 16, fontWeight: 'bold' }}>{group}</div>
                                                    <ul>{params.children}</ul>
                                                </li>
                                            );
                                        } else {
                                            return (
                                                <li key={params.key}>
                                                    <div style={{ marginLeft: 16, fontWeight: 'bold' }}>{"SEM PLANTA"}</div>
                                                    <ul>{params.children}</ul>
                                                </li>
                                            );
                                        }
                                    } else if (selectionState === 2) {
                                        if (subgroup !== ' ') {
                                            return (
                                                <li key={params.key}>
                                                    <div style={{ marginLeft: 16, fontWeight: 'bold' }}>{subgroup}</div>
                                                    <ul>{params.children}</ul>
                                                </li>
                                            );
                                        } else {
                                            return (
                                                <li key={params.key}>
                                                    <div style={{ marginLeft: 16, fontWeight: 'bold' }}>{"SEM OPERAÇÃO"}</div>
                                                    <ul>{params.children}</ul>
                                                </li>
                                            );
                                        }
                                    } else if (selectionState === 3) {
                                        if (group !== ' ' && subgroup !== ' ') {
                                            return (
                                                <li key={params.key}>
                                                    <div style={{ marginLeft: 16, fontWeight: 'bold' }}>{group}</div>
                                                    <div style={{ marginLeft: 30, fontStyle: 'italic' }}>{subgroup}</div>
                                                    <ul>{params.children}</ul>
                                                </li>
                                            );
                                        } else if (group === ' ' && subgroup !== ' ') {
                                            return (
                                                <li key={params.key}>
                                                    <div style={{ marginLeft: 16, fontWeight: 'bold' }}>{"SEM PLANTA"}</div>
                                                    <div style={{ marginLeft: 30, fontStyle: 'italic' }}>{subgroup}</div>
                                                    <ul>{params.children}</ul>
                                                </li>
                                            );
                                        } else if (group !== ' ' && subgroup === ' ') {
                                            return (
                                                <li key={params.key}>
                                                    <div style={{ marginLeft: 16, fontWeight: 'bold' }}>{group}</div>
                                                    <div style={{ marginLeft: 30, fontStyle: 'italic' }}>{"SEM OPERAÇÃO"}</div>
                                                    <ul>{params.children}</ul>
                                                </li>
                                            );
                                        } else {
                                            return (
                                                <li key={params.key}>
                                                    <div style={{ marginLeft: 16, fontWeight: 'bold' }}>{"SEM PLANTA E OPERAÇÃO"}</div>
                                                    <ul>{params.children}</ul>
                                                </li>
                                            );
                                        }
                                    }
                                } else {
                                    return (
                                        <li key={params.key}>
                                            <div style={{ fontWeight: 'bold' }}>{params.children}</div>
                                        </li>
                                    );
                                }
                            }}
                            value={inputValueVehicles}
                            onChange={(event, newValue) => { handleSelectVehicles(newValue) }}
                            renderInput={(params) => <TextField {...params} label="Veículos/Unidades"
                                slotprops={{
                                    input: {
                                        ...params.InputProps,
                                        endAdornment: (
                                            <Fragment>
                                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </Fragment>
                                        ),
                                    },
                                }}
                            />}
                            size="small"
                            sx={styleBorderField("100%")}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <Autocomplete
                            id="userType"
                            name="userType"
                            options={typeUsers}
                            onChange={(event, newValue) => handleSelectUserType(newValue)}
                            renderInput={(params) => <TextField {...params} label="Tipo de Usuário" required />}
                            defaultValue={defaultValues ? defaultValues.userType : ''}
                            size="small"
                            sx={styleBorderField("100%")}
                        />
                    </FormControl>
                </Grid>

                {showVehicles && <Grid item xs={12}>
                        <List dense style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                            {defaultValues ?
                                <AccordionForms
                                    title={"Veículos Adicionados"}
                                    width={"49%"}
                                    height={"70px"}
                                    children={
                                        <List dense style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                            {
                                                vehiclesSelected.map((element, index) => {
                                                    return (
                                                        <Paper elevation={3} variant="outlined" style={{ marginRight: "5px", marginTop: '2px', borderRadius: '32px', borderWidth: 2, height: '30px', display: 'flex', alignItems: 'center' }}>
                                                            <ListItem
                                                                secondaryAction={
                                                                    <IconButton
                                                                        edge="end"
                                                                        aria-label="delete"
                                                                        onClick={() => handleRemoveVehicle(index)}
                                                                        style={{ backgroundColor: 'rgb(251, 191, 180)', height: '20px', width: '20px' }}
                                                                    >
                                                                        <DeleteRoundedIcon color="error" fontSize={'small'} />
                                                                    </IconButton>
                                                                }
                                                            >
                                                                <ListItemText
                                                                    primary={element}
                                                                    disableTypography={true}
                                                                    style={{ fontSize: '10px' }}
                                                                />
                                                            </ListItem>
                                                        </Paper>
                                                    )
                                                })
                                            }
                                        </List>
                                    }
                                />
                                :
                                <AccordionForms
                                    title={"Veículos Adicionados"}
                                    width={"49%"}
                                    height={"70px"}
                                    children={
                                        <List dense style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                            {
                                                vehiclesSelected.map((element, index) => {
                                                    return (
                                                        <Paper elevation={3} variant="outlined" style={{ marginRight: "5px", marginTop: '2px', borderRadius: '32px', borderWidth: 2, height: '30px', display: 'flex', alignItems: 'center' }}>
                                                            <ListItem
                                                                secondaryAction={
                                                                    <IconButton
                                                                        edge="end"
                                                                        aria-label="delete"
                                                                        onClick={() => handleRemoveVehicle(index)}
                                                                        style={{ backgroundColor: 'rgb(251, 191, 180)', height: '20px', width: '20px' }}
                                                                    >
                                                                        <DeleteRoundedIcon color="error" fontSize={'small'} />
                                                                    </IconButton>
                                                                }
                                                            >
                                                                <ListItemText
                                                                    primary={element}
                                                                    disableTypography={true}
                                                                    style={{ fontSize: '10px' }}
                                                                />
                                                            </ListItem>
                                                        </Paper>
                                                    )
                                                })
                                            }
                                        </List>
                                    }
                                />
                            }
                        </List>
                    </Grid>
                }
                <Grid item xs={6}>
                    <TextField
                        label="Senha"
                        type={showPassword ? "text" : "password"}
                        id="password"
                        name="password"
                        error={showPasswordConfirmationError}
                        fullWidth
                        required={defaultValues ? false : true}
                        variant="outlined"
                        onChange={e => { setPasswordValue(e.target.value); checkPasswordMatch(e.target.value, '') }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password confirmation visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                    >
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        size="small"
                        sx={styleBorderField("100%")}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        label="Confirme a Senha"
                        type={showPasswordConfirmation ? "text" : "password"}
                        id="passwordConfirmation"
                        name="passwordConfirmation"
                        error={showPasswordConfirmationError}
                        helperText={showPasswordConfirmationError && "As senhas não são iguais."}
                        fullWidth
                        required={defaultValues ? false : true}
                        variant="outlined"
                        onChange={e => { setPasswordConfirmationValue(e.target.value); checkPasswordMatch('', e.target.value) }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPasswordConfirmation}
                                        onMouseDown={handleMouseDownPasswordConfirmation}
                                    >
                                        {showPasswordConfirmation ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        size="small"
                        sx={styleBorderField("100%")}
                    />
                </Grid>
                <Grid item xs={12} style={{ marginLeft: "12px" }} >
                    <FormControlLabel id="automaticReport" name="automaticReport" control={<Checkbox color="success" defaultChecked={false} checked={automaticReport} onChange={(event, newValue) => { handleAutomaticReport(newValue) }} />} label="Habilitar e-mail automático" />
                </Grid>
            </Grid >
        </FormLayout >
    );
}